/* eslint-disable no-console */
<template>
  <div class="add-switch-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="700px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">

        <el-form-item label="标题:" prop="title">
          <el-input v-model="params.title" size="small" placeholder="请输入消息标题"></el-input>
        </el-form-item>

        <el-form-item label="接受者:" prop="receiver">
          <el-select v-model="params.receiver" size="small" placeholder="请选择接受者">
            <el-option v-for="item in receiver" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户列表:" prop="uidList" v-if="params.receiver === 'SOME_USER'">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" placeholder="请输入用户列表，用“,”号隔开 如：123,456,789" v-model="userListStr" @input="changeUserList">
          </el-input>
        </el-form-item>
        <el-form-item label="内容:" prop="content">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" placeholder="请输入内容" v-model="params.content">
          </el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" placeholder="请输入备注" v-model="params.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">发 送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      dialogVisible: false,
      // 接受者
      receiver: [
        {
          label: "所有用户",
          value: 'ALL_USER',
        },
        {
          label: "部分用户",
          value: 'SOME_USER',
        },
      ],
      title: '',
      flag: false,
      operType: 'add',
      userListStr: '',
      // 请求参数
      params: {
        title: '',
        receiver: '',
        uidList: [],
        content: '',
        remark: '',
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        receiver: [{ required: true, message: '请选择接受者', trigger: 'change' }],
        content: [{ required: true, message: '请输入邮件内容', trigger: 'blur' }],
      }
    }
  },
  methods: {
    open(type) {
      this.dialogVisible = true;
      this.operType = type;
      if (type === 'add') {
        this.title = "新增邮件"
      }
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.operType === 'add') {
            this.addEmail()
          }
        } else {
          return false;
        }
      });
    },
    addEmail() {
      API.addEmail(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerEmail')
        } else {
          this.$message.error('新增失败,请重试');
        }
        this.handleClose();
        this.flag = false
      })
    },
    // 监听用户输入，转换用户id数组
    changeUserList(str) {
      this.params.uidList = str.split(',').map(Number)
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.userListStr = ""
      this.params = {
        title: '',
        receiver: '',
        enable: false,
        uidList: [],
        sendAt: '',
        content: '',
        remark: '',
      },
        this.$refs.form.resetFields()
    }
  }

}
</script>

<style lang="scss" >
.add-switch-box {
  .el-input {
    width: 200px !important;
  }
  .from-items {
    display: flex;
    .times {
      width: 440px !important;
      flex: none !important;
      margin-right: 20px;
    }
    .items {
      flex: 1;
    }
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
